/**
 * Different dermatoscope models.
 */
export enum Dermatoscope {
  Dermlite = 'dermlite',
  Melascope = 'melascope',
  Other = 'other',
}

export const DERMATOSCOPE_STORAGE_KEY = 'dermatoscope';

export const MELASCOPE_ALT_NAME = 'Iboolo';
